var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style.dateSelectInput,
        _vm.disabled ? _vm.$style.disabled : "",
        _vm.error && _vm.$style.error,
      ],
    },
    [
      _c(
        "div",
        { class: _vm.$style.input },
        [
          _vm._m(0),
          _c("Datepicker", {
            attrs: {
              id: _vm.id,
              language: _vm.locale,
              typeable: false,
              value: _vm.value,
              placeholder: _vm.placeholder,
              "input-class": _vm.$style.datePickerInput,
              "calendar-class": _vm.$style.datePickerCalendar,
              "minimum-view": _vm.minimumView,
              "maximum-view": _vm.maximumView,
              "open-date": new Date(_vm.openDate),
              "initial-view": "year",
              format: _vm.format,
              disabled: _vm.disabled,
            },
            on: { selected: _vm.handleSelect },
          }),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "slide-fade" } },
        [
          _vm.error
            ? _c("Error", [_vm._v(" " + _vm._s(_vm.error) + " ")])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { class: _vm.$style.icon }, [_c("IconCalendar")], 1)
  },
]
render._withStripped = true

export { render, staticRenderFns }